import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Button, Grid } from '@mui/material'

import { getSavedSearches } from 'store/actions/savedSearches'
import { selectSelectedFacets } from 'store/selectors/facets'
import { selectSavedSearches } from 'store/selectors/savedSearch'
import { selectHasExecutePermissions } from 'store/selectors/user'

import Pills from 'components/Pills'
import SaveMySearchModal from 'components/SaveMySearchModal'
import SavedSearchesModal from 'components/SavedSearchesModal'

const SearchHeader = ({ disableReset, onReset, searchText }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const dispatch = useDispatch()
  const [showSaveMySearchModal, setShowSaveMySearchModal] = useState(false)
  const [showSavedSearchesModal, setShowSavedSearchesModal] = useState(false)

  const hasExecutePermissions = useSelector(selectHasExecutePermissions)
  const selectedFacets = useSelector(selectSelectedFacets)
  const savedSearches = useSelector(selectSavedSearches)

  useEffect(() => {
    dispatch(getSavedSearches())
  }, [])

  return (
    <div className="Search-page">
      <Grid container>
        <div className="Row-search-header tw-items-center">
          <div className="Row-search-header--title tw-mb-2 lg:tw-mb-0">
            {!!searchText ? (
              <h3 className="tw-text-lg">
                {t.search.label} <i>"{searchText}"</i>
              </h3>
            ) : (
              <h3 className="tw-text-lg">{t.search.mainTitle}</h3>
            )}
          </div>

          <div className="Search-page__buttons-container">
            {hasExecutePermissions && (
              <Button
                className="main-button"
                onClick={() => setShowSaveMySearchModal(true)}
                variant="text"
              >
                {t.search.saveMySearch}
              </Button>
            )}
            {hasExecutePermissions && (
              <Button
                className="main-button"
                onClick={() => setShowSavedSearchesModal(true)}
                variant="text"
              >
                {t.search.viewMySearchs}
              </Button>
            )}
            <Button
              className="Material-cards__expanded-state add tw-mb-8"
              disabled={disableReset}
              onClick={onReset}
              variant="text"
            >
              {t.search.reset}
            </Button>
          </div>
        </div>

        <hr />

        <Grid size={{ xs: 12 }}>
          <Pills items={selectedFacets} />
        </Grid>
      </Grid>

      {showSaveMySearchModal && (
        <SaveMySearchModal
          showModal={showSaveMySearchModal}
          modalTitle={t.search.saveSearch.blockTitle}
          onDismiss={() => setShowSaveMySearchModal(false)}
        />
      )}

      {showSavedSearchesModal && (
        <SavedSearchesModal
          showModal={showSavedSearchesModal}
          modalTitle={t.search.savedSearch.blockTitle}
          onDismiss={() => setShowSavedSearchesModal(false)}
          savedSearches={savedSearches.results}
        />
      )}
    </div>
  )
}

SearchHeader.propTypes = {
  disableReset: PropTypes.bool.isRequired,
  onReset: PropTypes.func.isRequired
}

export default SearchHeader
